import React, { useState, useEffect } from 'react';
import { Button, Container, Grid, Typography } from "@mui/material"
import { makeStyles } from 'tss-react/mui';
import { useConciliacion } from '../hooks/useConciliacion';
import { useDispatch } from 'react-redux';
import { loadingModal } from 'src/redux-app';
import { filtrosConciliador } from '../../utils/constans/filtrosConciliador';
import { mapperAbonosPasarela } from '../../utils/mappers/mapperAbonosPasarela';
import ReporteConciliacionTable from '../components/ReporteConciliacionTable';
import { datosConciliador } from '../../utils/types/datosConciliador';
import { DatePicker } from '@mui/x-date-pickers';
import SearchIcon from '@mui/icons-material/Search';

const useStyles = makeStyles()(theme => ({
    container: {
        marginTop: theme.spacing(2)
    },
    input: {
        maxWidth: '500px',
    },
    datePicker: {
        width: '-webkit-fill-available',
        marginTop: '8px'
    }
}));

const ReporteConciliador = () => {
    const { classes, cx } = useStyles();
    const dispatch = useDispatch();

    const { getSomeConciliacion } = useConciliacion();
    const [filtros, setFiltros] = useState(filtrosConciliador);
    const [dataConciliacion, setDataConciliacion] = useState<datosConciliador[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchConciliaciones = async () => {
        setIsLoading(true);
        const result = await getSomeConciliacion(filtros);
        if (result) {
            setDataConciliacion(mapperAbonosPasarela(result));
        }
        setIsLoading(false);
    }

    const handleChangeFiltros = (campo: string, valor: any) => {
        setFiltros(() => {
            return { ...filtros, [campo]: valor };
        });
    };

    //Modal de espera
    function openWaitModal(load: boolean) {
        dispatch(loadingModal(load));
    }

    useEffect(() => {
        openWaitModal(isLoading);
    }, [isLoading]);

    useEffect(() => {
        fetchConciliaciones();
    }, [])

    return (
        <Container className={cx('containerbox', classes.container)} maxWidth="lg">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant='h4' gutterBottom align='center'>
                        Reporte Conciliador
                    </Typography>
                </Grid>
                <Grid container item xs={12} spacing={2}>
                    <Grid container item xs={12} spacing={1}>
                        <Grid container item xs={12} md={9} spacing={1}>
                            <Grid item xs={12} sm={6} md={3}>
                                <DatePicker
                                    name="fechaInicio"
                                    label="Fecha Inicio"
                                    format="dd/MM/yyyy"
                                    value={filtros.fechaIni}
                                    onChange={date => handleChangeFiltros('fechaIni', date)}
                                    className={cx(classes.input, classes.datePicker)}
                                    maxDate={filtros.fechaFin}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <DatePicker
                                    name="fechaFin"
                                    label="Fecha Fin"
                                    format="dd/MM/yyyy"
                                    value={filtros.fechaFin}
                                    onChange={date => handleChangeFiltros('fechaFin', date)}
                                    className={cx(classes.input, classes.datePicker)}
                                    minDate={filtros.fechaIni}
                                />
                            </Grid>
                        </Grid>
                        <Grid item sm={12} md={3} alignSelf='center'>
                            <Button variant="contained" fullWidth
                                onClick={fetchConciliaciones}
                                startIcon={<SearchIcon />}
                            >
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <ReporteConciliacionTable data={dataConciliacion} />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

export default ReporteConciliador;